import { render, staticRenderFns } from "./copyDialog.vue?vue&type=template&id=240af226&scoped=true"
import script from "./copyDialog.vue?vue&type=script&lang=js"
export * from "./copyDialog.vue?vue&type=script&lang=js"
import style0 from "./copyDialog.vue?vue&type=style&index=0&id=240af226&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@2.8.8_react-dom@18.2.0_react@_xj7bp7fq6ppsfq3zomxsdbctue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240af226",
  null
  
)

export default component.exports